<mat-card>{{'depositForMandoob' | translate}}</mat-card>



<div class="container" style="padding: 25px;">



    <mat-grid-list cols="4" rowHeight="50px">

        <mat-grid-tile cols="2">
            <mat-form-field appearance="fill" class="example-form-field" style="margin: 10px;;">
                <mat-label>{{'MandoobsMenu' | translate}}</mat-label>
                <mat-select [(value)]="selectedUser">
                    <mat-option *ngFor="let item of mandoobs" [value]="item.id">
                        {{item.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile cols="2">
            <mat-form-field appearance="fill" class="example-form-field">
                <mat-label>{{'enterDateRange' | translate}}</mat-label>
                <mat-date-range-input [rangePicker]="rangePicker">
                    <input matStartDate placeholder="Start date" #fromDate>
                    <input matEndDate placeholder="End date" #toDate>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
                        <button mat-raised-button color="primary" matDateRangePickerApply>{{'done' |
                            translate}}</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <button mat-raised-button color="primary" (click)="onApply()" style="margin-left: 10px;">
                <mat-icon>search</mat-icon>
                {{'filter' | translate}}
            </button>

            <button mat-raised-button color="primary" [disabled]="reports.length == 0" (click)="exportAsXLSX()">
                <mat-icon>import_export</mat-icon>
                {{'exportExcel' | translate}}
            </button>

        </mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>


    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort id="userTransTable">

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'dateTime' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.date}} </td>
                <td mat-footer-cell *matFooterCellDef>{{'total' | translate}}</td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'amount' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.amount}} </td>
                <td mat-footer-cell *matFooterCellDef>{{getTotalDeposit()}}</td>
            </ng-container>




            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}"</td>
            </tr>
        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>